import React, { createContext, useContext, useState, useEffect } from 'react';
import { isAuthenticated, getUsername, logout, login as apiLogin } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(false);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const authenticated = isAuthenticated();
      setIsAuth(authenticated);
      if (authenticated) {
        setUsername(getUsername());
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = async (username, password) => {
    const response = await apiLogin(username, password);
    localStorage.setItem('token', response.token);
    localStorage.setItem('username', response.username);
    setIsAuth(true);
    setUsername(response.username);
    return response;
  };

  const logoutUser = () => {
    logout();
    setIsAuth(false);
    setUsername('');
  };

  const value = {
    isAuthenticated: isAuth,
    username,
    login,
    logout: logoutUser,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};